// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Dictionary } from "@insite/client-framework/Common/Types";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { Draft } from "immer";

export interface VideoDocumentModel {
    link: string;
    isYoutubeVideo?: boolean;
    thumbnail?: string;
}

export type CustomProductState = {
    productId: string;
    videos: VideoDocumentModel[];
    selectedVideoIndex: number;
};

export type xProductDetailsStateType = {
    byId: Dictionary<CustomProductState>;
    leadTimeMessage: string;
    parentProductVariants?: ProductModel[];
};

const initialState: xProductDetailsStateType = {
    byId: {},
    leadTimeMessage: "",
};

const xProductDetails = createTypedReducerWithImmer(initialState, {
    "xProductDetails/SetCustomProductState": (
        draft: Draft<xProductDetailsStateType>,
        action: { customProductStates: CustomProductState[] },
    ) => {
        action.customProductStates.every(customProductState => {
            draft.byId[customProductState.productId] = {
                ...draft.byId[customProductState.productId],
                ...customProductState,
            };
            return true;
        });
    },
    "xProductDetails/SetSelectedVideoIndex": (
        draft: Draft<xProductDetailsStateType>,
        action: { index: number; product: ProductModel },
    ) => {
        draft.byId[action.product.id].selectedVideoIndex = action.index;
    },
    "xProductDetails/SetLeadTimeMessage": (draft: Draft<xProductDetailsStateType>, action: { message: string }) => {
        draft.leadTimeMessage = action.message;
    },
    "xProductDetails/SetParentProduct": (
        draft: Draft<xProductDetailsStateType>,
        action: { parentProductVariants: ProductModel[] },
    ) => {
        draft.parentProductVariants = action.parentProductVariants;
    },
});

export type xProductDetailsState = {
    xProductDetails: xProductDetailsStateType;
} & typeof reducers;

(reducers as any).xProductDetails = xProductDetails;
